var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C3.68966 1 1 3.73379 1 7.09847C1 9.53785 2.06759 11.8931 3.37517 13.8362C4.66621 15.7793 6.16414 17.2682 6.91724 17.9579L7 18L7.08276 17.9579C7.83586 17.2682 9.33379 15.7793 10.6248 13.8362C11.9324 11.8931 13 9.53785 13 7.09847C13 3.73379 10.3103 1 7 1ZM0 7.16363C0 3.20931 3.136 0 7 0C10.864 0 14 3.20931 14 7.16363C14 9.88991 12.824 12.4197 11.496 14.4173C10.168 16.415 8.656 17.9377 7.888 18.65C7.384 19.1167 6.616 19.1167 6.112 18.65C5.344 17.9377 3.832 16.415 2.504 14.4173C1.176 12.4197 0 9.88991 0 7.16363ZM7 5C5.89778 5 5 5.89778 5 7C5 8.10222 5.89778 9 7 9C8.10222 9 9 8.10222 9 7C9 5.89778 8.10222 5 7 5ZM4 7C4 5.344 5.344 4 7 4C8.656 4 10 5.344 10 7C10 8.656 8.656 10 7 10C5.344 10 4 8.656 4 7Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLocation);
export default __webpack_public_path__ + "static/media/ico-location.60db1798.svg";
export { ForwardRef as ReactComponent };